export const LOCAL_STORAGE = {
  ACCESS_TOKEN: 'accessTokenHiring',
};

export const SESSION_COOKIE = 'accessTokenHiring';
